import BolaoNovo from "./boloes/BolaoNovo";

export default function BolaoNovoPage() {
  return <BolaoNovo />;
}